import { render, staticRenderFns } from "./CompesationNew.vue?vue&type=template&id=1aab7744&scoped=true&"
import script from "./CompesationNew.vue?vue&type=script&lang=js&"
export * from "./CompesationNew.vue?vue&type=script&lang=js&"
import style0 from "./CompesationNew.vue?vue&type=style&index=0&id=1aab7744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab7744",
  null
  
)

export default component.exports